import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class AppSettingsService {

  menuState = new BehaviorSubject<Boolean>(true);

  headerState = new BehaviorSubject<Boolean>(true);

  constructor() { }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/app-settings.service.ts